import {createApi} from '@reduxjs/toolkit/query/react';
import baseQuery from 'src/redux/api/baseQuery';
import { UnidadAcademicaResponse } from './types/unidades-academicas';

/**
 * API para la gestion de unidades academicas
 * @see https://redux-toolkit.js.org/rtk-query/overview
 * @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
 *
 */
export const unidadesAcademicasApi = createApi({
	reducerPath: 'unidadesAcademicasApi',
	baseQuery,
	tagTypes: ['UnidadesAcademicas'],
	endpoints: (builder) => ({
		obtenerUnidadesAcademicas: builder.query<UnidadAcademicaResponse[], void>({
			query() {
				return {
					url: 'v1/unidades',
					method: 'GET',
					credentials: 'include',
				};
			},
			providesTags: ['UnidadesAcademicas'],
		}),
		obtenerUnidad: builder.query<UnidadAcademicaResponse, string>({
			query(unidadId) {
				return {
					url: `v1/unidades/${unidadId}`,
					method: 'GET',
					credentials: 'include',
				};
			},
		}),
		
	}),
});

export const {
	useLazyObtenerUnidadesAcademicasQuery,
	useObtenerUnidadesAcademicasQuery,
	useObtenerUnidadQuery,
} = unidadesAcademicasApi;
